export default "__VITE_ASSET__Zt454SHL__"